import {call, put, select, takeLatest} from "redux-saga/effects";

import {getCurrentCustomer} from "../Selectors/customers.selectors";
import {getCurrentSite} from "../Selectors/sites.selectors";

import {getInventoriesAsync} from "../AsyncActions/inventories.async";
import * as actions from "../action.constants";

export function* inventoriesRequest(action = {}) {
  const {pageUrl = "", trackPromise = true} = action;
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const currentSite = yield select(getCurrentSite);

    if (currentSite?.id) {
      const response = yield call(
        getInventoriesAsync,
        {
          customerId: currentCustomer?.id,
          siteId: currentSite?.id,
        },
        pageUrl,
        trackPromise
      );
      if (response) {
        yield put({type: actions.STORE_INVENTORIES, payload: response?.data});
      }
    }
  } catch (e) {
    /* empty */
  }
}

export function* sitesSaga() {
  yield takeLatest(actions.REQUEST_INVENTORIES_SAGA, inventoriesRequest);
}
